export default "__VITE_ASSET__64e8f9ef__"